import AccessToken from './AccessToken'
import User from './User'
import Role from './Role'
import Account from './Account'

export default class InitialResponse {
  constructor(
    public accessToken: AccessToken = new AccessToken(),
    public refreshToken: string = 'null',
    public user: User = new User(),
    public roles: Role[] = [],
  ) {}

  public static fromResponseObject(obj): InitialResponse {
    if (!obj) return new InitialResponse()

    const roles = [] as Role[]
    if (obj.roles) {
      obj.roles.forEach((element) => {
        roles.push(Role.fromResponseObject(element))
      })
    }

    return new InitialResponse(
      new AccessToken(obj.accessToken.token),
      obj.accessToken.refreshToken,
      User.fromResponseObject(obj.user),
      roles,
    )
  }
}
